import automatedTradingCurve from "./assets/automated-trading/automated-trading-ccl-curve.png";
import sharedBackground1 from "./assets/shared/share-card-shared-1.png";
import stakingLendingBackground1 from "./assets/staking-lending/staking-lending-background-1.png";
import stakingLendingBackground2 from "./assets/staking-lending/staking-lending-background-2.png";

export type ShareCardBackground = {
  key: string;
  image: string;
};

export const automatedTradingBackgrounds: ShareCardBackground[] = [
  { key: "automated-trading-ccl-curve", image: automatedTradingCurve },
  { key: "shared-1", image: sharedBackground1 },
];

export const stakingLendingBackgrounds: ShareCardBackground[] = [
  { key: "shared-1", image: sharedBackground1 },
  { key: "staking-lending-1", image: stakingLendingBackground1 },
  { key: "staking-lending-2", image: stakingLendingBackground2 },
];

export const defaultAutomatedTradingBackground = automatedTradingCurve;
export const defaultStakingLendingBackground = sharedBackground1;
